import React from 'react';
import tinycolor from 'tinycolor2';
import { Checkbox, Fieldset, Subsection, getCssVariable } from '@fourthwall/components';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { ColorInput } from '../ColorInput';
export const UsernameStyling = ({ form, verified }) => {
    const colorOnBackground = getCssVariable('--color-on-background');
    return (React.createElement(Subsection, { title: "Username styling" },
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Checkbox, { label: verified
                        ? 'Team members using this badge have a custom username color'
                        : 'Members using this badge have a custom username color', ...form.getFieldProps(FormFields.useCustomUsernameColor) })),
            form.values.useCustomUsernameColor && (React.createElement(Fieldset.Row, { inner: true },
                React.createElement(ColorInput, { label: "Username text color", color: form.values.usernameTextColor, defaultColor: tinycolor(colorOnBackground).toRgbString(), onChange: (color) => form.setFieldValue(FormFields.usernameTextColor, color) }))))));
};
